import React from 'react';
import axios from 'axios';
import {Accion} from '../comun/Index';

class Persona extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount(){}

  backgroundColor(estado, error){
    if (error) return("#F24B4B")
    switch (estado) {
      case "SIN ASIGNAR":
        return("white");
      case "PENDIENTE":
        return("#F2AF4B");
      case "RESUELTO":
        return("#2F968B");
        break;
      default:
        return("#F2AF4B");
    }
  }

  color(estado, error){
    if (error)
      return (null);
    return ('black')
  }

  render(){
    const {persona, seleccionar} = this.props;
    return(
      <div
        style={{
          width:'100%', padding:10, display:'flex', flexDirection:'row',
          flexWrap:'wrap', alignItems:'center', position:'relative',
          color: this.color(persona.estado, persona.error),
          backgroundColor: this.backgroundColor(persona.estado, persona.error)
        }}
      >
        <div style={{position:'absolute', right:30, display:'flex', flexDirection:'row'}}>
          <Accion
            icono="pin_drop"
            ayuda="Ubicar"
            backgroundColor="green"
            disabled={persona.error}
            onClick={() => this.props.seleccionar()}
          />
        </div>
        <div style={{paddingRight:50, display:'flex', flexDirection:'column'}}>
          <span>
            <strong>{persona.documento} - </strong>
            {persona.apellidos + ", " + persona.nombres}
          </span>
          <strong>
          {persona.localidad + " - " + persona.calle + " " + persona.numero}
          </strong>
        </div>
      </div>
    );
  }
}

export default class Padron extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      loading:false,
      seleccionado:null
    }
  }

  componentDidMount(){}

  seleccionar(persona){
    this.props.seleccionar(persona)
  }

  render(){
    const {seleccionado} = this.state;
    const {padron, seleccionados, habilitado} = this.props;
    return(
      <div className="Todo Index" style={{width:'95%', marginTop:0, paddingTop:0, color:'black'}}>
        <div style={{
          width:'100%', display:'flex', flexDirection:'column',
          borderWidth:1, borderRadius:10, backgroundColor:'#ccc2b8',
          overflowX:'hidden', height:600, overflowY:'scroll',
          backgroundColor: habilitado ? 'white' : 'lightgrey',
          color: habilitado ? 'black' : 'grey'
        }}>
          {padron.length !== 0 && padron.map((item, index) => {
            return(
              <span key={index}>
                <Persona
                  persona={item}
                  seleccionar={() => this.seleccionar(item)}
                />
                {padron.length - 1 !== index &&
                  <hr style ={{margin:0, padding:0, color:'lightgrey'}}/>
                }
              </span>
            )
          })}
          {padron.length === 0 &&
            <div
              style={{
                width:'100%', padding:10, cursor:'pointer',
                display:'flex', flexDirection:'row',
              }}
            >
              <span><strong>Sin padrón cargado</strong></span>
            </div>
          }
        </div>
      </div>
    );
  }
}
